import React from "react"
import {Select} from "@mui/material"
import MenuItem from "@mui/material/MenuItem"
import {Pagination} from "@mui/lab"
import {SelectChangeEvent} from "@mui/material"
export interface PaginationWrapperProps {
	currentPage: number
	elementsPerPage: number
	pagesNumber: number
	handlePageChange: (newPage: number) => void
	handleElementsPerPage: (elementsPerPage: number) => void
}

export default function PaginationWrapper(props: PaginationWrapperProps) {
	const handleUpdatePageNumber = (event: React.ChangeEvent<unknown> | null, newPage: number) => {
		props.handlePageChange(newPage)
	}

	return (
		<div style={{display: "flex", minHeight: "50px"}}>
			<Select
				color="primary"
				labelId="demo-simple-select-label"
				id="demo-simple-select"
				value={props.elementsPerPage}
				label="elementsPerPage"
				onChange={(event: SelectChangeEvent<number>) => {
					props.handleElementsPerPage(event.target.value as number)
				}}
			>
				<MenuItem value={5}>5</MenuItem>
				<MenuItem value={10}>10</MenuItem>
				<MenuItem value={25}>25</MenuItem>
				<MenuItem value={40}>40</MenuItem>
				<MenuItem value={100}>100</MenuItem>
			</Select>
			<Pagination
				style={{alignSelf: "center"}}
				count={props.pagesNumber}
				page={props.currentPage}
				color="primary"
				onChange={(event: React.ChangeEvent<unknown>, page: number) =>
					handleUpdatePageNumber(event, page)
				}
				boundaryCount={2}
				siblingCount={2}
			/>
		</div>
	)
}
